import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
// import cookie from "react-cookies";
import _ from "lodash";
import { History } from "history";
import showMsg from "zq-ui-v3/components/Message/Message";
import { isNull } from "zq-ui-v3/utils/utils";

export const baseURL = "/api/user";
export const tokenKey = "___USER_TOKEN";
export interface AxiosError extends Error {
  config: AxiosRequestConfig;
  code?: string | null | number;
  request?: any;
  response?: AxiosResponse;
}

// import { showMsg } from "../redux/actions";
// const { history } = require("../App");
let history: History;
let setOpenLogin: (openLogin: boolean) => void;

export const setupAxios = (h: History, setOpenLoginProps: (openLogin: boolean) => void) => {
  history = h;
  setOpenLogin = setOpenLoginProps;
};

const reqApi = axios.create({
  // api的base_url      process.env.BASE_URL
  baseURL,
  // 请求超时时间
  timeout: 1000 * 30,
});

export const genUrl = (url: string, param: any = {}): string => {
  const queryStr = Object.keys(param)
    .filter((k) => !isNull(param[k]))
    .map(
      (k) =>
        `${encodeURIComponent(k)}=${encodeURIComponent(
          _.isObject(param[k]) || _.isArray(param[k]) ? JSON.stringify(param[k]) : param[k],
        )}`,
    )
    .join("&");
  return `${url}${url.indexOf("?") > -1 ? "&" : "?"}${queryStr}`;
};

// 添加拦截器
reqApi.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token?.length) {
      config.headers["token"] = encodeURIComponent(token);
    }
    let data = config.data;
    if (data) {
      if (typeof data === "string") {
        data = JSON.parse(data);
      }
    }
    return config;
  },
  (error) => {
    // 请求错误处理
    // console.log('--- start request, error: ', error)
    Promise.reject(error);
  },
);

// 对响应的拦截
reqApi.interceptors.response.use(
  (response) => {
    // 成功请求到数据
    // 这里根据后端提供的数据进行对应的处理
    // console.log('--- response: ', response)
    if (response.status >= 400) {
      //  this.$q.notify(response.data.errMsg);
      console.log("--response:", response);
      Promise.reject(response);
      return;
    }
    // if (response.status === 200) {
    // }
    const { data } = response.data;
    return data;
  },
  (error) => {
    // 响应错误处理
    if (error.response?.data) {
      // console.log('-----', error.response.status)
      if (error.response.status === 401) {
        sessionStorage.removeItem("token");
        // cookie.remove(tokenKey);
        if (history) {
          console.log(history.location);
          sessionStorage.setItem("_last_req_url", String(history.location.pathname));
          // history.push("/sign-in");
          setOpenLogin(true);
        }
      } else {
        console.error("---", error.response.data);
        showMsg({ type: "error", content: error.response.data.errMsg });
      }
    }

    return Promise.reject(error);
  },
);

export const reqByGet = async (url: string, param: any = {}): Promise<AxiosResponse> =>
  await reqApi.get(genUrl(url, param));

export const queryMoreApi = async (param: any) => await reqByGet("/m/Api/query", param);

export const callApiByPath = async (
  type = "post",
  url = "",
  param: any = {},
): Promise<AxiosResponse> => {
  if (type === "get") return reqByGet(url, param);
  else return await reqApi[type](url, param);
};

export const queryByApi = async (
  module: string,
  entityName: string,
  api: string,
  param: any,
): Promise<AxiosResponse> => await reqByGet(`/${module}/${entityName}/${api}`, param);

export const exeByApi = async (
  module: string,
  entityName: string,
  api: string,
  param: any,
): Promise<AxiosResponse> => await reqApi.post(`/${module}/${entityName}/${api}`, param);

export const loadEntity = async (entityPath: string, entityId: string) =>
  await reqByGet(`${entityPath}/show`, { _id: entityId });

export default reqApi;
